import React from "react";
import Select from "react-select";

import connectToStores from "alt-utils/lib/connectToStores";

import UserStore from "../stores/UserStore";
import UserActions from "../actions/UserActions";

import OrganizationHealthUtil from "../utils/OrganizationHealthUtil";
import WorkingIndicator from "./partials/working-indicator.jsx";

const CHARTS_BASE_URL =
  "https://charts.mongodb.com/charts-eventive-production-cchlr";
const CHARTS_SCRIPT_URL = "https://unpkg.com/@mongodb-js/charts-embed-dom";

const CHARTS = [
  {
    id: "f0dc5c54-fbf1-4588-9212-4f9929b8a7aa",
    name: "USD-Only Ledger Billings By Month",
    getStyles: () => ({
      gridColumn: "1 / span 2"
    })
  },
  {
    id: "4b71466d-9b0e-4daf-9543-fbf8b02a9e92",
    name: "USD-Only Ledger Billings By Year",
    getStyles: () => ({
      gridColumn: "1 / span 2"
    })
  },
  {
    id: "c22b80df-4568-4336-89c5-b761c9260129",
    name: "Non-USD Ledger Billings By Month",
    filter: ({ user }) => user.currency !== "usd",
    getStyles: () => ({
      gridColumn: "1 / span 2"
    })
  },
  {
    id: "fce03c03-0446-4f23-82d4-da3a52f2d530",
    name: "Number of Unlock Fees Per Month"
  },
  {
    id: "2adac36d-957d-4cd0-8ed1-bd31455319a3",
    name: "Number of Tickets Per Month"
  }
];

class OrganizationHealth extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null
    };

    this.chartContainers = {};

    this.getChartSpecifications = this.getChartSpecifications.bind(this);
    this.renderCharts = this.renderCharts.bind(this);
    this.changeUser = this.changeUser.bind(this);
  }

  static getStores() {
    return [UserStore];
  }

  static getPropsFromStores() {
    return UserStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getChartSpecifications() {
    return CHARTS.filter(chart => {
      if (chart.filter) {
        return chart.filter({ user: UserStore.getUser() });
      }
      return true;
    });
  }

  renderCharts() {
    if (!UserStore.getUser() || !window.ChartsEmbedSDK) {
      setTimeout(() => this.renderCharts(), 100);
      return;
    }

    const { organization_id, chart_token } = this.state.data;

    const sdk = new window.ChartsEmbedSDK({
      baseUrl: CHARTS_BASE_URL,
      getUserToken: () => chart_token
    });

    this.getChartSpecifications().forEach(({ id, name }) => {
      const chart = sdk.createChart({
        chartId: id,
        filter: {
          _owner: { $eq: { $oid: organization_id } }
        },
        showAttribution: false
      });

      chart.render(this.chartContainers[id]);
    });
  }

  changeUser(userId) {
    UserActions.setGodUser(userId);
    this.setState({ data: null, isFetching: false });
  }

  componentWillReceiveProps() {
    if (!this.state.data && !this.state.isFetching) {
      this.setState({ isFetching: true });
      OrganizationHealthUtil.fetchOrganizationHealth(
        UserStore.getState().apiKey
      )
        .then(data => {
          this.setState({ isFetching: false, data }, () => {
            if (!document.querySelector(`script[src="${CHARTS_SCRIPT_URL}"]`)) {
              var script = document.createElement("script");
              script.type = "text/javascript";
              script.src = CHARTS_SCRIPT_URL;
              script.onload = () => setTimeout(this.renderCharts, 250);
              document.body.appendChild(script);
            } else {
              this.renderCharts();
            }
          });
        })
        .catch(e =>
          window.alert(`Failed to load Organization Health: ${e.message}`)
        );
    }
  }

  componentDidMount() {
    this.componentWillReceiveProps();
  }

  render() {
    const { condensedUsers } = this.props;
    const { data, isFetching } = this.state;

    if (!data || isFetching) {
      return (
        <WorkingIndicator fullPage={true} style={{ margin: "10% auto" }} />
      );
    }

    return (
      <div style={{ fontSize: "12pt", margin: "10px auto 0" }}>
        <h3 style={{ display: "flex", alignItems: "center" }}>
          <span style={{ whiteSpace: "nowrap" }}>Health of</span>
          <div
            style={{
              display: "inline-block",
              width: 350,
              marginLeft: 10
            }}
          >
            <Select
              clearable={false}
              value={data.organization_id}
              filterOption={(o, f) =>
                f.length > 2 &&
                o.label
                  .toLowerCase()
                  .indexOf((f || "").trim().toLowerCase()) !== -1
              }
              options={condensedUsers
                .filter(u => u.type !== "content_creator")
                .map(u => {
                  return {
                    label: u.organization,
                    value: u.id
                  };
                })}
              noResultsText="Type to search..."
              onChange={e => this.changeUser(e.value)}
            />
          </div>
        </h3>
        <p>
          This is a God-only view of the health of this organization since
          January 2021.
        </p>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            columnGap: "0em",
            rowGap: "0em"
          }}
        >
          {this.getChartSpecifications().map(({ id, name, getStyles }) => {
            return (
              <div
                style={{
                  height: 400,
                  ...(getStyles
                    ? getStyles({ user: UserStore.getUser() })
                    : null)
                }}
                ref={r => {
                  this.chartContainers[id] = r;
                }}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

export default connectToStores(OrganizationHealth);



// WEBPACK FOOTER //
// ./src/app/components/god-organization-health.jsx